import { createContext, useState, useContext, useMemo, useCallback } from 'react'
import { BranchDistrictContextType, IBranchDistrict, IDivision, IEmployee, IRegion } from "../@types/branchDistrict"
import { getBranchDistrict } from '../Services/branchDistrictService'
import { useEffectAsync } from '../Hooks/useEffectAsync'

const BranchDistrictContext = createContext<BranchDistrictContextType | null>(null)

const useBranchDistrictContext = () => {
    const context = useContext(BranchDistrictContext)
    if (context === undefined) {
        throw new Error("useBranchDistrictContext was used outside of its Provider");
    }
    return context
}

const BranchDistrictContextProvider = ({ children }: any) => {
    const [branchDistrict, setBranchDistrict] = useState<IBranchDistrict[]>([])
    const [employees, setEmployees] = useState<IEmployee[]>([])
    const [regions, setRegions] = useState<IRegion[]>([])
    const [divisions, setDivisions] = useState<IDivision[]>([])


    const load = useCallback(async () => {
        try {
            const response = await getBranchDistrict();
            if (response) {
                setBranchDistrict(response.branchHierarchyDistrict)
                setDivisions(response.branchHierarchyDivision)
                setRegions(response.branchHierarchyRegion)
                setEmployees(response.branchHierarchyEmployee)
            }
        } catch (error) {
            console.error(error)
        }
    },[])

    const providerValue = useMemo(() => ({
        branchDistrict, setBranchDistrict, regions, setRegions, divisions, setDivisions, employees, setEmployees, load
    }), [branchDistrict, regions, divisions, employees, load]);

    useEffectAsync(async () => {
        await load();
    }, [load])

    return (
        <BranchDistrictContext.Provider value={providerValue}>
            {children}
        </BranchDistrictContext.Provider>
    )
}

export { BranchDistrictContext, BranchDistrictContextProvider, useBranchDistrictContext };